import { render, staticRenderFns } from "./high-res-clipboard-images.vue?vue&type=template&id=70cabf92&scoped=true&lang=pug&"
import script from "./high-res-clipboard-images.vue?vue&type=script&lang=js&"
export * from "./high-res-clipboard-images.vue?vue&type=script&lang=js&"
import style0 from "./high-res-clipboard-images.vue?vue&type=style&index=0&id=70cabf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cabf92",
  null
  
)

export default component.exports